import React from 'react';
import styled, { DefaultTheme } from 'styled-components';
import { Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableCellsLarge } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../../context/ThemeContext';
import StoreSwitcher from '../../commonComponents/StoreSwitcher';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T =>
  props.theme?.mode === 'dark' ? darkValue : lightValue;

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const TitleIconBox = styled.span<{ theme?: DefaultTheme }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #2d6cca;
  color: #ffffff;
  font-size: 15px;
`;

const Title = styled(Typography.Title)<{ theme?: DefaultTheme }>`
  margin: 0 !important;
  font-weight: 700 !important;
  color: ${(props) => getThemeValue(props, '#f1f5f9', '#0f172a')} !important;
`;

const MenuHeader: React.FC = () => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  return (
    <HeaderSection>
      <TitleGroup>
        <TitleIconBox theme={theme}>
          <FontAwesomeIcon icon={faTableCellsLarge} />
        </TitleIconBox>
        <Title level={4} theme={theme}>
          Store Menu
        </Title>
      </TitleGroup>
      <StoreSwitcher />
    </HeaderSection>
  );
};

export default MenuHeader;
